import { render, staticRenderFns } from "./DetalheUploadEmail.vue?vue&type=template&id=6731af60&scoped=true"
import script from "./DetalheUploadEmail.vue?vue&type=script&lang=js"
export * from "./DetalheUploadEmail.vue?vue&type=script&lang=js"
import style0 from "./DetalheUploadEmail.vue?vue&type=style&index=0&id=6731af60&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6731af60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6731af60')) {
      api.createRecord('6731af60', component.options)
    } else {
      api.reload('6731af60', component.options)
    }
    module.hot.accept("./DetalheUploadEmail.vue?vue&type=template&id=6731af60&scoped=true", function () {
      api.rerender('6731af60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DetalheUploadEmail.vue"
export default component.exports